import React from 'react';

const SubmitConfirmModal = ({ 
  showSubmitConfirm,
  setShowSubmitConfirm,
  questions,
  answeredCount,
  markedForReview,
  tabSwitchCount,
  submitExam,
  submitting
}) => {
  if (!showSubmitConfirm) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">Submit Exam?</h3>
        
        <div className="space-y-3 mb-6">
          <div className="flex justify-between py-2 border-b">
            <span className="text-gray-600">Total Questions:</span>
            <span className="font-bold">{questions.length}</span>
          </div>
          <div className="flex justify-between py-2 border-b">
            <span className="text-gray-600">Answered:</span>
            <span className="font-bold text-green-600">{answeredCount}</span>
          </div>
          <div className="flex justify-between py-2 border-b">
            <span className="text-gray-600">Not Answered:</span>
            <span className="font-bold text-red-600">{questions.length - answeredCount}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Marked for Review:</span>
            <span className="font-bold text-purple-600">{markedForReview.size}</span>
          </div>
          {tabSwitchCount > 0 && (
            <div className="flex justify-between py-2 border-t border-red-200 bg-red-50 -mx-2 px-2">
              <span className="text-red-700 font-semibold">Tab Switches:</span>
              <span className="font-bold text-red-700">{tabSwitchCount}/5</span>
            </div>
          )}
        </div>

        <p className="text-gray-700 mb-6">
          Are you sure you want to submit? You won't be able to change your answers after submission.
        </p>

        <div className="flex gap-4">
          <button
            onClick={() => setShowSubmitConfirm(false)}
            disabled={submitting}
            className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={() => submitExam(false)}
            disabled={submitting}
            className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition disabled:opacity-50"
          >
            {submitting ? 'Submitting...' : 'Yes, Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmitConfirmModal;
